import { render, staticRenderFns } from "./NHHighScores.vue?vue&type=template&id=1183fa1c&"
import script from "./NHHighScores.vue?vue&type=script&lang=js&"
export * from "./NHHighScores.vue?vue&type=script&lang=js&"
import style0 from "./NHHighScores.vue?vue&type=style&index=0&id=1183fa1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports